import { ECategory } from '@r1-frontend/api-domru/api-profile/v1/spec-offer/update/dto/ResponseDto';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import Accordion from '@r1-frontend/ui-react/deprecated/Accordion';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import Link from 'next/link';
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import PopupForm from '~/src/components/PopupForm';
import { DISCONNECT_TEXT } from '~/src/constants';

import ChannelsList from '../channelsList';
import * as ST from './styled';

export const Container = styled.div`
    display: block;
    padding: 35px 60px;
    ${FONTS.M};
    background: #fff;
    overflow: auto;
    ${ST.BREAKPOINT} {
        ${FONTS.S};
        padding: 30px 20px 60px;
    }
`;

export const Header = styled.h2`
    ${FONTS.H2};
    margin-bottom: 15px;
    ${ST.BREAKPOINT} {
        ${FONTS.H3};
        margin-bottom: 10px;
    }
`;

export const GreyText = styled.div`
    display: block;
    margin-top: 25px;

    & > p > span {
        ${FONTS.S};
        color: black !important;
    }

    & > div {
        display: block;
    }

    & ul {
        list-style: disc;
        margin-left: 20px;
    }
`;

const Button = styled(BaseButton)`
    margin-top: 20px;

    @media (max-width: 400px) {
        width: 100%;
    }
`;

const AccordionTitle = styled.div`
    font-size: calc( (100vw - 320px)/(1920 - 320) * (32 - 18) + 18px);
    line-height: calc( (100vw - 320px)/(1920 - 320) * (40 - 22) + 22px);
`;

const AccordionWrapper = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

const AccContent = styled.div`
    display: block;
`;

const POPUP_TYPE_OFFER = 'offer';
const POPUP_TYPE_AUTH = 'auth';

class PopupOffer extends React.Component {
    static defaultProps = {
        activate: () => {
        },
        offer: {
            channels: [],
        },
    };

    constructor(props) {
        super(props);
        const { isAuth } = this.props;
        this.state = {
            popupType: isAuth ? POPUP_TYPE_OFFER : POPUP_TYPE_AUTH,
        };
    }

   formCondition = () => {
        const { offer: { paySum } } = this.props;
        if (!paySum) {
            return <></>;
        }
        if (paySum > 0) {
            return <GreyText>Чтобы воспользоваться предложением, <Link
                href='/payments'><a>пополните
                счет</a></Link> на {paySum} руб.</GreyText>;
        }

        return <GreyText>Услуга подключится мгновенно.</GreyText>;
    }

    formTerms = () => {
        const { offer: { terms } } = this.props;
        if (!terms) {
            return <></>;
        }
        return <GreyText dangerouslySetInnerHTML={{ __html: terms }}/>;
    }

    onClose = () => {
        const { onClose } = this.props;
        onClose();
    };

    onActivate = () => {
        const { isAuth, activate } = this.props;

        if (isAuth) {
            activate();
        } else {
            this.setState({ popupType: POPUP_TYPE_AUTH });
        }
    };

    handleClick = event => {
        event.currentTarget.disabled = true;
        this.onActivate();
    };

    renderContent = (isDisconnect) => {
        const { activate, isConnected, offer } = this.props;
        const { childOffers = [], channels, closeDate } = offer;
        const buttonText = offer.button_text || 'Подключить';

        if (childOffers.length === 0 || isDisconnect) {
            return (
                <React.Fragment>
                    <ChannelsList channels={channels}/>
                    <CloseOfferText closeOfferDate={closeDate}/>
                    {!isConnected && this.formCondition()}
                    {
                        <Button text={isConnected ? 'Отключить' : buttonText} onClick={this.handleClick}/>
                    }
                    {!isConnected && this.formTerms()}
                </React.Fragment>
            );
        }

        return <ChildOffers
            childOffers={childOffers}
            isConnected={isConnected}
            onActivateClick={activate}
            closeOfferDate={closeDate}
        />;
    };

    renderPopupAuth = () => {
        const { offer, isOpen } = this.props,
        returnUrl = encodeURIComponent('/promo?offersType=gifts' + (offer.id ? '&offerId=' + offer.id : '')),
        getParams = `?referrer=${returnUrl}`;

        return (
            <PopupForm
                getParams={getParams}
                onClose={this.onClose}
                isOpen={isOpen}
            />
        );
    };

    renderPopupOffer = () => {
        const { offer, category, isOpen } = this.props;
        const title = offer.title;
        const isActive = category === ECategory.connected;
        const description = offer.description || offer.body_full;
        const wholeSaleTitle = <>
            { isActive ? 'Отключить' : 'Подключить' } услугу &laquo;Оптом дешевле&raquo;?
        </>;

        const isDisconnect = title?.includes('Оптом дешевле')  && isActive;

        return (
            <ST.Popup onClose={this.onClose} isOpen={isOpen}>
                <Container>
                    <Header>{isDisconnect ? wholeSaleTitle : title}</Header>
                    <GreyText dangerouslySetInnerHTML={{ __html: isDisconnect ? DISCONNECT_TEXT : description }} />
                    {
                        this.renderContent(isDisconnect)
                    }
                </Container>
            </ST.Popup>
        );
    };

    render() {

        return (
            POPUP_TYPE_OFFER === this.state.popupType
                ? this.renderPopupOffer()
                : this.renderPopupAuth()
        );
    }
}

export function ChildOffers({ childOffers, isConnected, closeOfferDate, onActivateClick, color }) {
    const [openAcc, setIsOpenAcc] = useState({});

    const handleOpen = useCallback((id) => {
        setIsOpenAcc({ [id]: true });
    }, [childOffers]);

    return childOffers.map(offer => (
        <AccordionWrapper key={offer.id}>
            <Accordion
                title={<AccordionTitle>{offer.title}</AccordionTitle>}
                open={openAcc[offer.id] === true}
                onOpen={() => handleOpen(offer.id)}
            >
                <AccContent>
                    <GreyText
                        color={color}
                        dangerouslySetInnerHTML={{ __html: offer.description }}
                    />
                    <ChannelsList channels={offer.channels}/>
                    {
                        isConnected
                            ? <CloseOfferText closeOfferDate={closeOfferDate}/>
                            : <Button text='Подключить' onClick={() => onActivateClick(offer.id)}
                            />
                    }
                </AccContent>
            </Accordion>
        </AccordionWrapper>
    ));
}

function CloseOfferText({ closeOfferDate }) {
    const date = (new Date(closeOfferDate)).toLocaleDateString('ru');
    if (!closeOfferDate) {
        return <></>;
    }

    return <GreyText>Если вы подключите бонус сейчас, скидка по акции продлится до {date}.
        После этой даты она отключится автоматически, а тариф дальше будет по полной стоимости.</GreyText>;
}

const mapStateToProps = (state) => ({
    isAuth: state.auth.isAuth,
});

export default connect(mapStateToProps)(PopupOffer);
